module.exports = __webpack_public_path__ + "img/8.b4c73377.png";